export function computeRequired(baseRequired, uiSchema, jsonformState) {
  const rw = uiSchema?.options?.requiredWhen;
  if (!rw) return baseRequired;
  const keyFromScope = rw.scope?.startsWith("#/properties/")
    ? rw.scope.replace("#/properties/", "")
    : undefined;
  const ruleKey = rw.key || keyFromScope;
  if (!ruleKey) return baseRequired;
  const currentVal = jsonformState?.[ruleKey];
  const enumCheck = Array.isArray(rw.enum) ? rw.enum.includes(currentVal) : false;
  const constCheck = rw.const !== undefined ? rw.const === currentVal : false;
  return baseRequired || enumCheck || constCheck;
}
